module.exports = __webpack_public_path__ + "siteminder-fav-icon.png?55c55068cfe0d5cec14b443cade4aa67";